export default __webpack_public_path__ + "static/media/BE-flag.e5faf885.svg";